module.exports = __webpack_public_path__ + "static/apple-store-badge-f29d439990278266f1fc4e8d379f14b3.svg";